import { WSSTag } from "@foundation/metadata";
import { AdDemand } from "@foundation/sparkle";

// To extend custom Refresh across various adTypes
export enum AdKey {
    RIGHT_RAIL = "rightRail",
}

const FLAGGED_CONTENT_TAG_IDS = new Set<string>(["war", "terror", "terrorism"]);

export const isAdSafeContent = (contentTags: WSSTag[]) =>
    !contentTags.some((tag) => FLAGGED_CONTENT_TAG_IDS.has(tag?.id));

// For now disable ad if paywalled for all demand levels
export const showFirstRightRailAd = (
    fortressAllowed: boolean,
    _: AdDemand = "low"
) => fortressAllowed;
